import { useRecoilState } from 'recoil';
import userState from '../../recoil/atoms/auth/user';
import { getUserData } from '../Utils';

const useUserState = () => useRecoilState(userState);

export default useUserState;
